<template>
  <v-container>
    <v-card width="800" elevation="0" outlined tile>
      <v-card-title class="headline my-3">現場図の作成</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <div>名前</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              outlined
              solo
              single-line
              style="max-width: 450px;"
              flat
              dense
              hide-details
              v-model="form.name"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>画像</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-file-input
              outlined
              solo
              single-line
              style="max-width: 450px;"
              flat
              dense
              hide-details
              v-model="form.image"
            ></v-file-input>
          </v-col>
        </v-row>

        <template v-if="admin">
          <v-row>
            <v-col>
              <div>現場グループ</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                :items="site_groups"
                item-text="name"
                item-value="id"
                style="max-width: 450px;"
                v-model="form.site_group_id"
              ></v-select>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-btn elevation="0" tile class="px-5" @click="$router.go(-1)">
          <span class="font-weight-bold">キャンセル</span></v-btn
        >
        <v-btn
          elevation="0"
          tile
          color="success"
          class="px-5"
          @click="register"
        >
          <span class="font-weight-bold">登録する</span></v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import api from "@/api";
import { mapGetters } from "vuex";

export default {
  name: "ConstructionSiteNew",
  data() {
    return {
      form: {
        name: "",
        image: null,
        site_group_id: null,
      },
      site_groups: [],
    };
  },
  computed: {
    ...mapGetters("user", { admin: "isAdmin" }),
  },
  async created() {
    this.site_groups = await api.site_groups.list();
  },
  methods: {
    register() {
      let formData = new FormData();
      formData.append("name", this.form.name);
      formData.append("image", this.form.image);
      formData.append("site_group_id", this.form.site_group_id);

      api.construction_sites.create(formData).then((resp) => {
        this.$router.push({
          name: "ConstructionSiteDetail",
          params: { id: resp.id },
        });
      });
    },
  },
};
</script>
